import { render, staticRenderFns } from "./SampleLayout.vue?vue&type=template&id=6b6b1c64"
import script from "./SampleLayout.vue?vue&type=script&lang=js"
export * from "./SampleLayout.vue?vue&type=script&lang=js"
import style0 from "./SampleLayout.vue?vue&type=style&index=0&id=6b6b1c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports